import darkText from './darkText.module.scss';
import lightText from './lightText.module.scss';

export { darkText, lightText };
